module.exports = angular.module('cartographer.map.featuremap', [])

_ = require 'underscore'

module.exports.factory 'crtFeatureMapSelection', $DI (crtLog, crtConfig, crtLocation) ->
  class crtFeatureMapSelection
    # (-> arrayOf(feature) [or(feature, null)] [number] [arrayOf(feature)] -> void
    constructor: (@getFeatures, @_direct = null, @_radius = crtConfig.map.defaultSelectionRadius, @_nearbyCache = null) ->
      # Do nothing

    # -> or(feature, null)
    direct: =>
      @_direct

    # -> or(location, null)
    location: =>
      @direct()?.geometry

    # -> arrayOf(feature)
    nearby: =>
      if @direct()
        @_nearbyCache ?= _.filter(@getFeatures(), (f) => @contains(f.geometry))
      else
        @_nearbyCache ?= []
      @_nearbyCache

    # -> number
    radius: =>
      @_radius

    isEmpty: =>
      @nearby().length == 0

    nonEmpty: =>
      @nearby().length > 0

    # -> crtFeatureMapSelection
    copy: =>
      new crtFeatureMapSelection(@getFeatures, @direct(), @radius(), @_nearbyCache)

    # number -> selection
    withDirect: (direct) =>
      new crtFeatureMapSelection(@getFeatures, direct, @radius())

    # number -> selection
    withRadius: (radius) =>
      new crtFeatureMapSelection(@getFeatures, @direct(), radius)

    # location -> boolean
    contains: (loc) =>
      location   = @location()
      if location?
        radiusIn = @radius() ? 0
        location && (crtLocation.distance(location, loc) <= radiusIn)
      else
        false

    # feature -> boolean
    isDirect: (feature) =>
      @direct() && feature.id == @direct().id

    # feature -> boolean
    isNearby: (feature) =>
      !!_.find(@nearby(), (f) -> feature.id == f.id)

  # (-> arrayOf(feature)) [or(feature null)] [number] -> crtFeatureMapSelection
  create = (getFeatures, direct = null, radius = crtConfig.map.defaultSelectionRadius) ->
    new crtFeatureMapSelection(getFeatures, direct, radius)

  return {
    create
  }

module.exports.directive 'crtFeatureMap', $DI (crtLog, crtConfig, crtLocation, crtFeatureMapSelection) ->
  return {
    restrict: 'A'
    template: require './feature-map.tpl.html'
    scope:
      features          : '='  # arrayOf(feature)
      buckets           : '='  # crtAttributeBuckets
      attribution       : '=?' # arrayOf(string)
      location          : '=?' # location
      zoom              : '=?' # [1,20]
      mapTiles          : '=?' # or('terrain', 'satellite')
      fixed             : '=?' # boolean
      scrollWheel       : '=?' # boolean
      selection         : '=?' # crtFeatureMapSelection
      onBoundsChange    : '=?' # neLocation swLocation -> void
      onSelectionChange : '=?' # crtMapFeatureSelection -> void
      fullscreen        : '=?' # boolean
    controllerAs: 'crtFeatureMap'
    bindToController: true
    controller: $DI ($scope) ->
      crtFeatureMap = this

      # Fullscreen ------------------------------

      crtFeatureMap.fullscreen ?= false

      # Center and zoom -------------------------

      # TODO: Remove hard-coded defaults:
      crtFeatureMap.location     ?= crtLocation.london()
      crtFeatureMap.zoom         ?= crtConfig.map.defaultZoom
      crtFeatureMap.fixed        ?= false
      crtFeatureMap.scrollWheel  ?= true
      crtFeatureMap.mapTiles     ?= crtConfig.map.defaultTiles

      # Features/paths --------------------------

      crtFeatureMap.paths        ?= {}

      minSelectionZooms = for zoom in [1...20]
        # Each zoom level doubles the size of the map.
        # This formula makes the selection circle just visible around
        # a map marker at all levels of zoom:
        [ Math.pow(2, (14 - zoom)) / 10, zoom ]

      minSelectionZoom = (radius) ->
        for [ threshold, zoom ] in minSelectionZooms when radius >= threshold
          return zoom
        return 21 # radius too small -- never display it

      updateSelectionRadius = ->
        # crtLog.debug('crtFeatureMap.updateSelectionRadius', { location: crtFeatureMap.selection.location(), radius: crtFeatureMap.selection.radius() })
        if crtFeatureMap.selection?.location() && crtFeatureMap.zoom >= minSelectionZoom(crtFeatureMap.selection.radius())
          crtFeatureMap.paths._selection = {
            type        : "circle"
            stroke      : false
            fillColor   : "#fff"
            fillOpacity : 0.5
            latlngs     : crtLocation.toLngLatObject(crtFeatureMap.selection.location())
            radius      : crtFeatureMap.selection.radius() # meters
            clickable   : false
          }
        else
          delete crtFeatureMap.paths._selection
        return

      updatePaths = ->
        _visitedIds = []

        crtFeatureMap.paths = {}

        updateSelectionRadius()

        for feature in crtFeatureMap.features ? []
          pathId = _featureIdToMarkerId(feature.id)
          _visitedIds.push(pathId)
          unless crtFeatureMap.paths[pathId]?
            path = crtFeatureMap.buckets.createPath(feature, crtFeatureMap.selection.isNearby(feature))
            crtFeatureMap.paths[pathId] = path

        for pathId of crtFeatureMap.paths when _visitedIds.indexOf(pathId) == -1
          delete crtFeatureMap.paths[pathId]

        # crtLog.debug('crtFeatureMap.updatePaths', crtFeatureMap.selection, crtFeatureMap.paths)

        return

      $scope.$watch('crtFeatureMap.zoom',                       updateSelectionRadius)
      $scope.$watch('crtFeatureMap.features',                   updatePaths)
      $scope.$watch('crtFeatureMap.buckets',                    updatePaths)

      $scope.$watch('crtFeatureMap.selection.direct()',         updatePaths)
      $scope.$watch('crtFeatureMap.selection.nearby()',         updatePaths)

      # Selection -------------------------------

      crtFeatureMap.selection         ?= crtFeatureMapSelection.create(-> crtFeatureMap.features)
      crtFeatureMap.onSelectionChange ?= (->)

      updateSelection = (loc, directId) ->
        direct = _.find crtFeatureMap.features, (feature) ->
          directId && directId == feature.id
        crtFeatureMap.selection = crtFeatureMap.selection.withDirect(direct)
        # crtLog.debug('crtFeatureMap.updateSelection', loc, directId, crtFeatureMap.selection)
        return

      crtFeatureMap.onMapClick = (loc) ->
        # crtLog.debug('crtFeatureMap.onMapClick', loc)
        updateSelection(null, null)
        # updatePaths() # this is done by watching the selection
        crtFeatureMap.onSelectionChange(crtFeatureMap.selection)
        return

      crtFeatureMap.onMarkerClick = (loc, markerId) ->
        # crtLog.debug('crtFeatureMap.onMarkerClick', loc, markerId)
        updateSelection(loc, _markerIdToFeatureId(markerId))
        # updatePaths() # this is done by watching the selection
        crtFeatureMap.onSelectionChange(crtFeatureMap.selection)
        return

      crtFeatureMap.onPathClick = (loc, pathId) ->
        # crtLog.debug('crtFeatureMap.onMarkerClick', loc, markerId)
        updateSelection(loc, _markerIdToFeatureId(pathId))
        # updatePaths() # this is done by watching the selection
        crtFeatureMap.onSelectionChange(crtFeatureMap.selection)
        return

      _markerIdPrefix = "m_"
      _markerIdPrefixLength = _markerIdPrefix.length

      # string -> string
      _featureIdToMarkerId = (featureId) ->
        _markerIdPrefix + featureId.replace(/-/g, "_")

      # string -> string
      _markerIdToFeatureId = (markerId) ->
        markerId.substring(_markerIdPrefixLength).replace(/_/g, "-")

      return
  }
